// Card de alertas del piso (`GET /seller/home`), compartida por el Home y «Mi tienda». Separa las
// tres lecturas: cargando, fallida y sin alertas — un cero que nadie midió se lee como turno limpio.
import type { ReactNode } from 'react';
import { Loading } from '@/kit';
import { plural } from '@/shared/lib/format/plural';
import type { SellerAlert } from '../api/usePortal';
import { HomeCard, HomeEmpty } from './HomeCard';

export function AlertsCard({
    title,
    emptyText,
    alerts,
    isPending,
    isError,
    onRetry,
    className,
    renderAlert,
}: {
    title: string;
    emptyText: string;
    alerts: SellerAlert[];
    isPending: boolean;
    isError: boolean;
    onRetry: () => void;
    /** Cómo se estira la card dentro de su columna (`flex-1` en la última del mock). */
    className?: string;
    renderAlert: (alert: SellerAlert) => ReactNode;
}) {
    return (
        <HomeCard
            title={title}
            meta={alertsMeta(alerts.length, isPending, isError)}
            className={className}
        >
            {isPending ? (
                <Loading />
            ) : isError ? (
                <div role="alert" className="px-3 py-2.5 text-[11px]">
                    <p>No se pudieron leer las alertas del piso.</p>
                    <button
                        type="button"
                        className="mt-1 text-primary hover:underline"
                        onClick={onRetry}
                    >
                        Reintentar
                    </button>
                </div>
            ) : alerts.length === 0 ? (
                <HomeEmpty>{emptyText}</HomeEmpty>
            ) : (
                alerts.map(renderAlert)
            )}
        </HomeCard>
    );
}

/** Contador de la cabecera. Sin lectura buena NO dice «0 activas»: ese cero nadie lo midió. */
function alertsMeta(count: number, isPending: boolean, isError: boolean): string {
    if (isPending) return 'leyendo…';
    if (isError) return 'sin lectura';
    return plural(count, 'activa', 'activas');
}
